export const languageCountries = {
  "English": {
    countries: [
      "USA", "GBR", "CAN", "AUS", "NZL", "IRL", "GUY", "ZAF", "NGA", "KEN", 
      "GHA", "UGA", "SGP",  "ZWE", "BWA", "NAM", "LBR", "JAM",
      "SLE", "CMR", "MWI", "RWA", "TZA", "ZMB", "SWZ", "LSO", "FJI", "SLB", 
      "PNG"
    ],
    zoom: {
      scale: 90,
      translation: [0.5, 0.7],
      rotation: [0, 0, 0]
    }
  },
  "Patois": {
    countries: [
      "JAM", "TTO", "GRD", "LCA", "VCT", "ATG", "KNA", "DMA", "GUY", "BHS", 
      "BRB", "BLZ"
    ],
    zoom: {
      scale: 280,
      translation: [1, 0.8],
      rotation: [0, 0, 0]
    }
  },
  "Spanish": {
    countries: [
      "ESP", "MEX", "ARG", "COL", "PER", "VEN", "CHL", "ECU", "GTM", "CUB", 
      "BOL", "DOM", "HND", "PRY", "SLV", "NIC", "CRI", "PAN", "URY", "GNQ"
    ],
    zoom: {
      scale: 180,
      translation: [0.8, 0.5],
      rotation: [0, 0, 0]
    }
  },
  "Korean": {
    countries: [
      "KOR", "PRK"
    ],
    zoom: {
      scale: 280,
      translation: [-0.4, 1],
      rotation: [0, 0, 0]
    }
  },
  "German": {
    countries: [
      "DEU", "AUT", "CHE", "LUX", "LIE", "BEL"
    ],
    zoom: {
      scale: 180,
      translation: [0.5, 1],
      rotation: [0, 0, 0]
    }
  },
  "French": {
    countries: [
      "FRA", "BEL", "CHE", "CAN", "LUX", "MCO", "CMR", "COD", "COG", "CIV", 
      "DJI", "GNQ", "GAB", "HTI", "MDG", "MLI", "NER", "RWA", "SEN", "TCD", 
      "TGO", "VUT", "BEN", "BFA", "BDI", "CAF", "COM", "GNB", "LBN", "MRT", 
      "SEY"
    ],
    zoom: {
      scale: 180,
      translation: [0.4, 0.7],
      rotation: [0, 0, 0]
    }
  }
}; 